import script from "./YingBiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./YingBiPage.vue?vue&type=script&setup=true&lang=js"

import "./YingBiPage.vue?vue&type=style&index=0&id=5587f120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5587f120"]])

export default __exports__